@if (multiple) {
  <p-multiselect
    data-testid="paginated-select-multiselect"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [options]="options"
    optionLabel="label"
    optionValue="value"
    [inputId]="inputId"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [disabled]="disabled"
    [class]="styleClass"
    [panelStyleClass]="panelStyleClass"
    [appendTo]="appendTo"
    [scrollHeight]="scrollHeight"
    [filter]="filter"
    [filterBy]="filterBy"
    [loading]="loading"
    [lazy]="lazy"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    optionDisabled="disabled"
    (onFilter)="onFilter($event.filter)"
    (onLazyLoad)="onLazyLoad($event)"
    [ngClass]="{ 'p-invalid': invalid }"
  >
    <ng-template let-option pTemplate="item">
      @if (option?.loading) {
        <div
          data-testid="paginated-select-loading-option"
          class="dropdown-loading-more-option"
        >
          <span
            class="dropdown-loading-more-spinner"
            aria-hidden="true"
          ></span>
        </div>
      } @else {
        <span
          [attr.data-testid]="'paginated-select-option-' + option?.value"
          >{{ option?.label }}</span
        >
      }
    </ng-template>
  </p-multiselect>
} @else {
  <p-select
    data-testid="paginated-select-select"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [options]="options"
    optionLabel="label"
    optionValue="value"
    [inputId]="inputId"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [disabled]="disabled"
    [class]="styleClass"
    [panelStyleClass]="panelStyleClass"
    [appendTo]="appendTo"
    [filter]="filter"
    [filterBy]="filterBy"
    [loading]="loading"
    [lazy]="lazy"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    optionDisabled="disabled"
    (onFilter)="onFilter($event.filter)"
    (onLazyLoad)="onLazyLoad($event)"
    [filterPlaceholder]="'common.search.form.actions.search' | translate"
    [ngClass]="{ 'p-invalid': invalid }"
    [appendTo]="appendTo"
  >
    <ng-template let-option pTemplate="item">
      @if (option?.loading) {
        <div
          data-testid="paginated-select-loading-option"
          class="dropdown-loading-more-option"
        >
          <span
            class="dropdown-loading-more-spinner"
            aria-hidden="true"
          ></span>
        </div>
      } @else {
        <span
          [attr.data-testid]="'paginated-select-option-' + option?.value"
          >{{ option?.label }}</span
        >
      }
    </ng-template>
  </p-select>
}
